import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const releasePhoneNumber = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-whatsapp-phone',
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
    });
}